import { Component, Input } from '@angular/core';

@Component({
  selector: 'valg-card-information-content',
  templateUrl: './card-information-content.component.html'
})
export class CardInformationContentComponent {
  @Input() title!: string;
  @Input() message!: string;
}
